
const  csharp = `
using System;
using System.Net.Http;
using System.Security.Cryptography.X509Certificates;
using System.Threading.Tasks;
using System.Security.Cryptography;
class Program
{
    static void Main(string[] args)
    {
        string API_KEY = "";
        string API_SECRET = "";
        string HOST = "HHOOSSTT";
        var api = new
        {
            uri = "AAPPII",
            method = "MMEETTHHOODD",
            // payload = new    //payload example
            // {
            //     symbol= "BTC-USDT",
            //     recvWindow= 0
            // }
            payload = new
            PPAAYYLLOOAADD,
            protocol = "https"
        };

        DoRequest(api.protocol, HOST, api.uri, api.method, API_KEY, API_SECRET, api.payload).Wait();
    }

    static async Task DoRequest(string protocol, string host, string api, string method, string API_KEY, string API_SECRET, object payload)
    {
        long timestamp = DateTimeOffset.Now.ToUnixTimeMilliseconds();
        string parameters = $"timestamp={timestamp}";

        if (payload != null)
        {
            foreach (var property in payload.GetType().GetProperties())
            {
                parameters += $"&{property.Name}={property.GetValue(payload)}";
            }
        }

        string sign = CalculateHmacSha256(parameters, API_SECRET);
        string url = $"{protocol}://{host}{api}?{parameters}&signature={sign}";

        Console.WriteLine("protocol: " + protocol);
        Console.WriteLine("method: " + method);
        Console.WriteLine("host: " + host);
        Console.WriteLine("api: " + api);
        Console.WriteLine("parameters: " + parameters);
        Console.WriteLine("sign: " + sign);
        Console.WriteLine(method + " " + url);

        using (HttpClientHandler handler = new HttpClientHandler())
        {
            handler.ServerCertificateCustomValidationCallback = (sender, cert, chain, sslPolicyErrors) => true;

            using (HttpClient client = new HttpClient(handler))
            {
                client.DefaultRequestHeaders.Add("X-BX-APIKEY", API_KEY);
                HttpResponseMessage response;
                if (method.ToUpper() == "GET")
                {
                    response = await client.GetAsync(url);
                }
                else if (method.ToUpper() == "POST")
                {
                    response = await client.PostAsync(url, null);
                }
                else if (method.ToUpper() == "DELETE")
                {
                    response = await client.DeleteAsync(url);
                }
                else if (method.ToUpper() == "PUT")
                {
                    response = await client.PutAsync(url, null);
                }
                else
                {
                    throw new NotSupportedException("Unsupported HTTP method: " + method);
                }
                response.EnsureSuccessStatusCode();
                string responseBody = await response.Content.ReadAsStringAsync();
                Console.WriteLine("Response status code: " + response.StatusCode);
                Console.WriteLine("Response body: " + responseBody);
            }
        }
    }

    static string CalculateHmacSha256(string input, string key)
    {
        byte[] keyBytes = System.Text.Encoding.UTF8.GetBytes(key);
        byte[] inputBytes = System.Text.Encoding.UTF8.GetBytes(input);
        using (HMACSHA256 hmac = new HMACSHA256(keyBytes))
        {
            byte[] hashBytes = hmac.ComputeHash(inputBytes);
            return BitConverter.ToString(hashBytes).Replace("-", "").ToLower();
        }
    }
}`
export default  csharp



// WEBPACK FOOTER //
// ./src/utils/code/csharp.js